import React, { FunctionComponent, useEffect } from 'react'
import { Message, Text } from '@afterpaytouch/core'
import { Trans, useTranslation } from 'next-i18next'
import { AppLink } from '../../AppLink'
import { Route } from '../../../config/router'
import { IdentityErrorCode } from '@afterpaytouch/portal-api/identity/config'
import { IdentityDocument, IdentityPiece } from '../../../model'
import { TrackingEvent } from '../../../model/monitoring'
import styles from '../styles.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'

interface IdentityErrorMessageProps {
  identityType: IdentityDocument | IdentityPiece
  error?: IdentityErrorCode | null
  testNameSpace?: string
}

const ANALYTIC_ERROR: Record<IdentityDocument | IdentityPiece, string> = {
  licence: 'Hard_ID_Decline_Licence',
  medicare: 'Hard_ID_Decline_Medicare',
  passport: 'Hard_ID_Decline_Passport',
  address: 'Soft_ID_Decline_Address',
}

export const ErrorMessage: FunctionComponent<IdentityErrorMessageProps> = ({ error, identityType: docType, testNameSpace = '' }) => {
  const { t } = useTranslation()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  useEffect(() => {
    if (typeof error !== 'undefined' && error !== null) {
      logEvent(TrackingEvent.VIEWED_NON_TERMINAL_ERROR, { errorCode: ANALYTIC_ERROR[docType] })
    }
  }, [error])

  if (typeof error === 'undefined' || error === null) {
    return null
  }
  const renderError = (
    <Text renderAs={'span'} size='XS'>
      <Trans i18nKey={`verifyIdentity:error:${error}`} components={{ changeVerification: <AppLink noMargin inline route={Route.VERIFY_IDENTITY} /> }} />
    </Text>
  )

  const OPTIONS = {
    [IdentityErrorCode.IdentityAlreadyRejected]: {
      kind: 'Info',
      iconName: 'WarningAlt',
      heading: `${t('verifyIdentity:error:unableToRetryHeading')}`,
    },
    Other: {
      kind: 'Error',
      iconName: 'Profile',
      heading: `${t('verifyIdentity:error:errorHeading')}`,
    },
  }

  return (
    <div className={styles.messageWrapper}>
      <Message {...(OPTIONS[error] ?? OPTIONS.Other)} description={renderError} testNameSpace={testNameSpace} />
    </div>
  )
}
